<div
  data-test="3qOnlVoo"
  class="modal modal-right"
  id="editTransport"
  [class.active]="show"
>
  <div data-test="FRD7udL2" class="modal__overlay" (click)="close()"></div>
  <div data-test="KA5xlahT" class="modal__wrap">
    <div data-test="arBSiXEw" class="modal__window">
      <div data-test="3gNzXIRZ" class="modal__content">
        <md-loader data-test="7YZaKiUt" *ngIf="showLoader" context="absolute"></md-loader>
        <button data-test="P7vZIHBr" class="modal__close" type="button" (click)="close()">
          <span data-test="BjpUXMay" class="badge badge_gray">
            <i data-test="AMYTz5EG" class="material-icons md-12">close</i>
          </span>
        </button>
        <div
          data-test="mmdwLAM-"
          class="modal__content-wrap scrollbar-hidden"
          data-simplebar
        >
          <div data-test="CQoulXRM" class="modal__container">
            <div data-test="1p44HbTD" class="modal__body">
              <ng-content></ng-content>
            </div>
          </div>
        </div>
        <footer data-test="v4lwzT3L" class="modal__footer">
          <div data-test="T5NvhZpl" class="modal__container">
            <div data-test="HnPZpEnL" class="modal__footer-wrap row gutters-20">
              <div
                data-test="YGNeLW2G"
                *ngFor="let button of buttons | keyvalue"
                class="col-auto"
              >
                <button
                  data-test="Q5NQPHkx"
                  type="button"
                  class="button button_secondary"
                  [class.button_primary]="button.value.primary"
                  [class.button_secondary]="!button.value.primary"
                  (click)="onButtonPress(button.key)"
                >
                  {{ button.value.title }}
                </button>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</div>
